import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const VariantSettingsThemeLogo = (props) => {
  const [contextData, builder, setContextData] = useContext(VariantContextData);
  let website = contextData.objects.website;
  let cta = contextData.objects.cta;
  let variant = contextData.objects.variant;
  
  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Logos" open={false}>
        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-format]"
          setting_type="dropdown"
          object_type="variants"
          label="Logo Format"
          value={variant.options["logo-format"]}
          options={[
            { value: "image", text: "Image" },
            { value: "icon", text: "Icon" },
          ]}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-style]"
          setting_type="dropdown"
          object_type="variants"
          label="Logo Style"
          value={variant.options["logo-style"]}
          options={[
            { value: "dark", text: "Dark Brand Style" },
            { value: "light", text: "Light Brand Style" },
            { value: "custom", text: "Custom Image Upload" },
          ]}
          show_reset={true}
        />

        {variant.options["logo-style"] !== "custom" && (
          <div className="row hard-center">
            <div className="col-xs-12">
              <p className="text-base text-black">
                Upload light/dark logos in website <a href={`/websites/${website.id}/edit`} target='_blank'>settings →</a>
              </p>
            </div>
          </div>
        )}

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-image]"
          setting_type="image"
          object_type="variants"
          label="Custom Image URL"
          value={variant.options["logo-image"]}
          show_reset={true}
          callback={() => {
            builder.update([
              {
                object_type: "variants",
                object_id: variant.id,
                setting_name: "[options][logo-style]",
                value: "custom",
                skip_history: true,
              },
            ]);
          }}
        />

        <VariantBuilderSetting
          object={variant}
          label="Control"
          setting_name="[options][logo-control-style]"
          setting_type="dropdown"
          object_type="variants"
          value={
            variant.options["logo-control-style"]
              ? variant.options["logo-control-style"]
              : undefined
          }
          options={[
            { value: "width", text: "Width" },
            { value: "height", text: "Height" },
          ]}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Control"
          setting_name="[options][logo-control-style-mobile]"
          setting_type="dropdown"
          object_type="variants"
          value={
            variant.options["logo-control-style-mobile"]
              ? variant.options["logo-control-style-mobile"]
              : variant.options["logo-control-style"]
                ? variant.options["logo-control-style"]
                : "width"
          }
          options={[
            { value: "width", text: "Width" },
            { value: "height", text: "Height" },
          ]}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-image-width]"
          setting_type="range"
          object_type="variants"
          label={"Logo Max Width"}
          value={variant.options["logo-image-width"]}
          device="desktop"
          condition={
            variant.options["logo-control-style"] !== "height"
          }
          placeholder={"Auto"}
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-image-width-mobile]"
          setting_type="range"
          object_type="variants"
          label={"Logo Max Width"}
          condition={
            (variant.options["logo-control-style-mobile"] || variant.options["logo-control-style"] || "width") == "width"
          }
          placeholder={variant.options["logo-image-width"] || "Auto"}
          value={
            variant.options["logo-image-width-mobile"]
              ? variant.options["logo-image-width-mobile"]
              : undefined
          }
          device="mobile"
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-image-height]"
          setting_type="range"
          object_type="variants"
          label={"Logo Max Height"}
          value={variant.options["logo-image-height"]}
          device="desktop"
          condition={
            variant.options["logo-control-style"] == "height"
          }
          placeholder={"Auto"}
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-image-height-mobile]"
          setting_type="range"
          object_type="variants"
          label={"Logo Max Height"}
          condition={
            (variant.options["logo-control-style-mobile"] || variant.options["logo-control-style"] || "width") == "height"
          }
          placeholder={variant.options["logo-image-height"] || "Auto"}
          value={
            variant.options["logo-image-height-mobile"]
              ? variant.options["logo-image-height-mobile"]
              : undefined
          }
          device="mobile"
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-link]"
          setting_type="text"
          object_type="variants"
          label="Logo Link"
          placeholder={website.data["logo-link"] ? website.data["logo-link"] : "https://"}
          value={variant.options["logo-link"]}
          allow_empty={true}
          show_reset={true}
          tooltip={`Override website default logo link. <br><u><a href='/websites/${website.id}/edit' target='_blank'>Edit Default →</a></u>`}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-link-new-tab]"
          setting_type="checkbox"
          object_type="variants"
          label="Open in New Tab"
          value={variant.options["logo-link-new-tab"]}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][logo-alt-text]"
          setting_type="text"
          object_type="variants"
          label="Logo Alt Text"
          placeholder="Image Alt Text"
          value={variant.options["logo-alt-text"]}
          allow_empty={true}
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default VariantSettingsThemeLogo;
